import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../components/common/Loading';
import Error from '../components/common/Error';
import ReelInspectionsHeader from '../components/inspections/ReelInspections/ReelInspectionsHeader';
import ReelInspectionsFilter from '../components/inspections/ReelInspections/ReelInspectionsFilter';
import ReelInspectionsReelsList from '../components/inspections/ReelInspections/ReelInspectionsReelsList';

import { useSessionContext } from '../contexts/SessionContext';

export default function ReelInspectionsPage( props ){
    //console.debug("RTS Break ReelInspectionsPage");

    const {curFilter, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [filter, setFilter] = useState();
    const [data, setData] = useState([]);

    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/Reels/GetReelsSummary";
        axios
        .post(
            apiURL,
            pFilter,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status == 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token]);

    
    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'ReelInspectionsPage'){
            setFilter(curFilter.filter);
            fetchData(curFilter.filter);
        }
        else{
            setFilter({reelType:null, status:1});
            fetchData({reelType:null, status:1})
        }
    }, [props, curFilter, fetchData]); 


    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '75vh';
        }
        return retValue;
    };    


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    return(
        <Box>
            <ReelInspectionsHeader />
            <ReelInspectionsFilter filter={filter} setFilterFx={setFilter}/>
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                <ReelInspectionsReelsList data={data} />
            </Box>
        </Box>
    );
}
